import ImportsView from '../ImportsView.vue'
import DespegarHistory from '../Pages/DespegarHistory.vue'
import DespegarUpload from '../Pages/DespegarUpload.vue'

// DEF-ADM-022 — Importación de viajes desde Excel. Vive en Administración
// (nivel 1): un mismo archivo trae viajes de varias ciudades, así que no
// depende de la ciudad activa.
const routes = [
  {
    path: '/administracion/importar',
    component: ImportsView,
    name: 'imports',
    children: [
      {
        // Pantalla principal: historial de importaciones.
        path: 'despegar',
        name: 'imports-despegar',
        component: DespegarHistory
      },
      {
        // Carga del archivo: subir, revisar el preview y confirmar.
        path: 'despegar/cargar',
        name: 'imports-despegar-upload',
        component: DespegarUpload
      }
    ]
  }
]

export default routes
